import { render, staticRenderFns } from "./Tarefa.vue?vue&type=template&id=22320024&"
import script from "./Tarefa.vue?vue&type=script&lang=js&"
export * from "./Tarefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports